/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Guarantee of the claims history grid (Variable MRI file) — DDE dégât des eaux, INC incendie, DOM dommages électriques, TNG tempête/neige/grêle, CNAT catastrophe naturelle, CTEC catastrophe technologique, RC responsabilité civile propriétaire, CHOC choc de véhicule, VVAN vol/vandalisme, BDG bris de glace, BDM bris de machine.
 * @export
 */
export const ClaimGuaranteeCode = {
    Dde: 'DDE',
    Inc: 'INC',
    Dom: 'DOM',
    Tng: 'TNG',
    Cnat: 'CNAT',
    Ctec: 'CTEC',
    Rc: 'RC',
    Choc: 'CHOC',
    Vvan: 'VVAN',
    Bdg: 'BDG',
    Bdm: 'BDM'
} as const;
export type ClaimGuaranteeCode = typeof ClaimGuaranteeCode[keyof typeof ClaimGuaranteeCode];


export function instanceOfClaimGuaranteeCode(value: any): boolean {
    for (const key in ClaimGuaranteeCode) {
        if (Object.prototype.hasOwnProperty.call(ClaimGuaranteeCode, key)) {
            if (ClaimGuaranteeCode[key as keyof typeof ClaimGuaranteeCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClaimGuaranteeCodeFromJSON(json: any): ClaimGuaranteeCode {
    return ClaimGuaranteeCodeFromJSONTyped(json, false);
}

export function ClaimGuaranteeCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimGuaranteeCode {
    return json as ClaimGuaranteeCode;
}

export function ClaimGuaranteeCodeToJSON(value?: ClaimGuaranteeCode | null): any {
    return value as any;
}

export function ClaimGuaranteeCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): ClaimGuaranteeCode {
    return value as ClaimGuaranteeCode;
}

